import React from "react";
import { colors } from "../../constants/theme";
import type { Item } from "../../types";
import { TextInput } from "../ui/TextInput";

interface MetadataEditorProps {
  item: Item;
  onMetaChange: (field: keyof NonNullable<Item["meta"]>, value: string) => void;
}

export const MetadataEditor: React.FC<MetadataEditorProps> = ({ item, onMetaChange }) => (
  <>
    {/* Metadata */}
    <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
      <TextInput label="Artist" value={item.meta?.artist || ""} onChange={(v) => onMetaChange("artist", v)} />
      <TextInput label="Title" value={item.meta?.title || ""} onChange={(v) => onMetaChange("title", v)} />
      <TextInput label="Date" value={item.meta?.date || ""} onChange={(v) => onMetaChange("date", v)} />
      <div />
      <TextInput label="Description" multiline rows={4} value={item.meta?.description || ""} onChange={(v) => onMetaChange("description", v)} style={{ gridColumn: "1 / -1" }} />
    </div>

    {/* Related images */}
    <div style={{ marginTop: 12 }}>
      <div style={{ color: colors.text, fontWeight: 700, marginBottom: 8 }}>Related images</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {(item.related ?? []).map((u, idx) => (
          <img key={idx} src={u} alt={`rel_${idx}`} style={{ width: 84, height: 64, objectFit: "cover", borderRadius: 6, border: `1px solid ${colors.border}` }} />
        ))}
      </div>
    </div>
  </>
);

